import Sidebar from './Sidebar'
import sidebarContainer from './sidebarContainer'

export default sidebarContainer(Sidebar)
